module.exports = __webpack_public_path__ + "img/slightly-smiling-face.91842b8c.svg";